
export function calculateConceptualAge(birthDate, gestationalAgeWeeks) {
  const conceptionDate = calculateConceptionDate(birthDate, gestationalAgeWeeks);

  const now = new Date();
  now.setHours(0, 0, 0, 0); // Align both to start of day

  const diffMs = now.getTime() - conceptionDate.getTime();
  const diffWeeks = diffMs / (1000 * 60 * 60 * 24 * 7); // MS → weeks

  return diffWeeks;
}

export function calculateConceptionDate(birthDate, gestationalAgeWeeks) {
  const birthDateObj = new Date(birthDate);
  const daysToSubtract = gestationalAgeWeeks * 7;

  // Set time to start of day (like withTimeAtStartOfDay in Joda)
  birthDateObj.setHours(0, 0, 0, 0);

  const conceptionDate = new Date(birthDateObj);
  conceptionDate.setDate(conceptionDate.getDate() - daysToSubtract);

  return conceptionDate;
}